import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import ErrorBoundary from "./components/ErrorBoundary";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { AuthProvider } from "./context/AuthContext";
import Panelo from "./components/Panelo";
import Home from "./pages/Home";
import Exams from "./pages/Exams";
import Panel from "./pages/Panel";
import Book from "./pages/Book";
import SampleReport from "./pages/SampleReport";
import AboutContact from "./pages/AboutContact";
import Login from "./pages/Login";
import Studio from "./pages/Studio";
import Leads from "./pages/Leads";
import AuthCallback from "./pages/AuthCallback";

/* Detect the Google sign-in redirect (session_id in the URL fragment)
   synchronously during render, before any session check runs. */
const Shell = ({ theme, onToggleTheme }) => {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <div className="flex min-h-screen flex-col bg-paper font-body text-ink">
            <Navbar theme={theme} onToggleTheme={onToggleTheme} />
            <div className="flex-1">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/exams" element={<Exams />} />
                    <Route path="/panel" element={<Panel />} />
                    <Route path="/book" element={<Book />} />
                    <Route path="/report" element={<SampleReport />} />
                    <Route path="/about" element={<AboutContact />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/studio" element={<Studio />} />
                    <Route path="/admin/leads" element={<Leads />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </div>
            <Footer />
            <Panelo />
        </div>
    );
};

function App() {
    const [theme, setTheme] = useState(() => {
        try {
            return localStorage.getItem("tpr-theme") || "light";
        } catch {
            return "light";
        }
    });

    useEffect(() => {
        document.documentElement.classList.toggle("dark", theme === "dark");
        try {
            localStorage.setItem("tpr-theme", theme);
        } catch {
            /* private mode */
        }
    }, [theme]);

    /* Calm momentum scrolling */
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1 });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollToTop />
                <AuthProvider>
                    <Shell
                        theme={theme}
                        onToggleTheme={() =>
                            setTheme((t) => (t === "dark" ? "light" : "dark"))
                        }
                    />
                </AuthProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
